export default __webpack_public_path__ + "static/media/circle_check.b8f4b06a.svg";